var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loPage',[_c('loSection',[_c('loArticle',[_c('mdFace',{attrs:{"classStr":"is-bad"}},[_c('span',[_vm._v(_vm._s(_vm.$t('site.status.dataUndefined')))])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }